import { render } from "./login-footer.vue?vue&type=template&id=59a3f6ba&scoped=true"
import script from "./login-footer.vue?vue&type=script&lang=js"
export * from "./login-footer.vue?vue&type=script&lang=js"

import "./login-footer.vue?vue&type=style&index=0&id=59a3f6ba&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a3f6ba"]])

export default __exports__